// A screen that waits on the network gives up after a fixed time (SPEC-14
// and SPEC-15: "max 10 s"), whatever the request is still doing.

export class Timeout extends Error {
  override name = "Timeout";
}

/** `work`, or a Timeout rejection once `ms` have passed. */
export function within<T>(work: Promise<T>, ms: number): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new Timeout()), ms);
  });
  return Promise.race([work, timeout]).finally(() => clearTimeout(timer));
}
